type ListItem = {
  content?: string;
  meta?: {
    checked?: boolean;
  };
};

type ListProps = {
  data?: ListItem[];
  className?: string;
  type?: 'ordered' | 'checklist' | string;
};

export default function List ({ data, className = '', type }: ListProps) {
  const ListTag = type === 'ordered' ? 'ol' : 'ul'

  return (
    <ListTag className={className}>
      {data?.map((el, i) => {
        if (type === 'checklist') {
          return (
            el.content && (
              <li key={`${el.content}-${i}`}>
                <label>
                  <input
                    type="checkbox"
                    checked={el.meta?.checked ?? false}
                    readOnly
                  />
                  <span dangerouslySetInnerHTML={{ __html: el.content }}></span>
                </label>
              </li>
            )
          )
        }
        return (
          el.content && (
            <li
              key={`${el.content}-${i}`}
              dangerouslySetInnerHTML={{ __html: el.content }}
            />
          )
        )
      })}
    </ListTag>
  )
}
